import * as types from '../mutation-types'
import { api } from '@/modules/api'

const state = {
  attendeesMessages: [],
  attendeesMessagesTotalItems: null,
  attendeesMessagesTotalPages: null
}

const getters = {
  getAttendeesMessages: state => state.attendeesMessages,
  getMessagesTotalItems: state => state.attendeesMessagesTotalItems,
  getMessagesTotalPages: state => state.attendeesMessagesTotalPages
}

const actions = {
  async fetchAttendeesMessages ({commit}, payload = {}) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const response = await this.$axios.get(api.attendeesMessages.getAttendeesMessages(payload))
      commit(types.SET_ATTENDEES_MESSAGES, response.data)
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Error on fetching attendees messages')
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  }
}

const mutations = {
  [types.SET_ATTENDEES_MESSAGES] (state, {messages, totalItems, totalPages}) {
    state.attendeesMessages = [...messages]
    state.attendeesMessagesTotalItems = totalItems
    state.attendeesMessagesTotalPages = totalPages
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/attendees-messages.js